import { ResgateConsultaService } from 'src/app/services/http/resgate-consulta.service';
import { Component } from '@angular/core';
import { Router, ActivationEnd, NavigationStart } from '@angular/router';
import { LoginService } from './services/login.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Union Solutions';
  theme = 'deep-blue';
  readonly supportNumber = '5511963056359';
  readonly supportWhatsappUrl = `https://wa.me/${this.supportNumber}?text=Ol%C3%A1%2C%20preciso%20de%20ajuda.`;

  hideNavigation: boolean;
  user = null;
  isLandingPage = false;

  constructor(private router: Router, private loginService: LoginService, private themeService: ThemeService, private _resgateConsultaService: ResgateConsultaService) {
    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationStart && event.url.indexOf('#') > -1) {
          this.router.navigate([event.url.replace('#', 'hash')]);
          return;
        }
        if (event instanceof ActivationEnd && !event.snapshot.firstChild) {
          this.hideNavigation = event.snapshot.data['hideNavigation'];
          this.isLandingPage = event.snapshot.data?.['isLandingPage'] === true;

          if (this.user && this.user.unidade && this.user.unidade.cor) {
            this.themeService.setTheme(this.user.unidade.cor);
          }
        }
      });
    this.loginService.getLogIn().subscribe( user => this.user = user );
    this.themeService.getTheme().subscribe( t => this.theme = t );
    this._resgateConsultaService.consultaAtualizando.subscribe(e =>{
      this._resgateConsultaService.atualizarStatusGlobal(e);
    })
  }
  clickBtnMaluco(){
    return null;
  }
}
